export default __webpack_public_path__ + "264fd3aa7e8b50c04de83dc515449bd7.png";